// v-reveal: adds `is-visible` once the element scrolls into view.
// Pair it with the `reveal` class in the template (see layout.css).
// Don't use it on an element that also has a :class binding — Vue rewrites
// the class list on re-render and would drop `is-visible`.
export default {
  mounted(el) {
    el._revealObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          el._revealObserver.disconnect();
        }
      },
      // Fire when the element's top edge passes 15% up from the bottom of the screen.
      // A pixel margin (not a % threshold) so very tall elements still trigger.
      { threshold: 0, rootMargin: "0px 0px -15% 0px" }
    );
    el._revealObserver.observe(el);
  },
  unmounted(el) {
    el._revealObserver?.disconnect();
  },
};
